/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ APP_NAME: NonNullable<unknown> }} Link_Order_Page_TitleInputs */

const en_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link Order | ${i?.APP_NAME}`)
};

const id_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link Order | ${i?.APP_NAME}`)
};

const ms_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pautkan Tempahan | ${i?.APP_NAME}`)
};

const ca_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enllaç de comanda | ${i?.APP_NAME}`)
};

const cs_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odkaz na objednávku | ${i?.APP_NAME}`)
};

const da_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link-rækkefølge | ${i?.APP_NAME}`)
};

const de_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestellung verknüpfen | ${i?.APP_NAME}`)
};

const et_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tellimuse sidumine | ${i?.APP_NAME}`)
};

const es_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vincular el pedido | ${i?.APP_NAME}`)
};

const fr_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lier l’achat | ${i?.APP_NAME}`)
};

const hr_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Povezivanje narudžbe | ${i?.APP_NAME}`)
};

const it_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Collega ordine | ${i?.APP_NAME}`)
};

const lv_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piesaistīt pasūtījumu | ${i?.APP_NAME}`)
};

const lt_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Susieti užsakymą | ${i?.APP_NAME}`)
};

const hu_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendelés hivatkozása | ${i?.APP_NAME}`)
};

const nl_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link bestelling | ${i?.APP_NAME}`)
};

const nb_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koble til bestilling | ${i?.APP_NAME}`)
};

const pl_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Połącz zamówienia | ${i?.APP_NAME}`)
};

const pt_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vincular pedido | ${i?.APP_NAME}`)
};

const ro_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conectează comanda | ${i?.APP_NAME}`)
};

const sk_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odkaz na objednávku | ${i?.APP_NAME}`)
};

const sl_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Povezava do naročila | ${i?.APP_NAME}`)
};

const fi_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linkitä tilaus | ${i?.APP_NAME}`)
};

const sv_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Länkordning | ${i?.APP_NAME}`)
};

const vi_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Liên kết đơn hàng | ${i?.APP_NAME}`)
};

const tr_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bağlantı Sırası | ${i?.APP_NAME}`)
};

const el_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Σύνδεση παραγγελίας | ${i?.APP_NAME}`)
};

const bg_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Свързване на поръчка | ${i?.APP_NAME}`)
};

const ru_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ссылка заказа${i?.APP_NAME}`)
};

const sr_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Повезивање наруџбине | ${i?.APP_NAME}`)
};

const uk_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Замовлення посилання | ${i?.APP_NAME}`)
};

const ka_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ბმულის თანმიმდევრობა | ${i?.APP_NAME}`)
};

const hi_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लिंक आर्डर | ${i?.APP_NAME}`)
};

const th_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ลิงก์การสั่งซื้อ | ${i?.APP_NAME}`)
};

const ko_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`주문 연결 | ${i?.APP_NAME}`)
};

const zh_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`链接订单 | ${i?.APP_NAME}`)
};

const zh_tw_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`連結順序 | ${i?.APP_NAME}`)
};

const ja_link_order_page_title = /** @type {(inputs: Link_Order_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link Order｜ ${i?.APP_NAME}`)
};

/**
* | output |
* | --- |
* | "Link Order \| {APP_NAME}" |
*
* @param {Link_Order_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const link_order_page_title = /** @type {((inputs: Link_Order_Page_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Order_Page_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_link_order_page_title(inputs)
	if (locale === "ms") return ms_link_order_page_title(inputs)
	if (locale === "ca") return ca_link_order_page_title(inputs)
	if (locale === "cs") return cs_link_order_page_title(inputs)
	if (locale === "da") return da_link_order_page_title(inputs)
	if (locale === "de") return de_link_order_page_title(inputs)
	if (locale === "et") return et_link_order_page_title(inputs)
	if (locale === "es") return es_link_order_page_title(inputs)
	if (locale === "fr") return fr_link_order_page_title(inputs)
	if (locale === "hr") return hr_link_order_page_title(inputs)
	if (locale === "it") return it_link_order_page_title(inputs)
	if (locale === "lv") return lv_link_order_page_title(inputs)
	if (locale === "lt") return lt_link_order_page_title(inputs)
	if (locale === "hu") return hu_link_order_page_title(inputs)
	if (locale === "nl") return nl_link_order_page_title(inputs)
	if (locale === "nb") return nb_link_order_page_title(inputs)
	if (locale === "pl") return pl_link_order_page_title(inputs)
	if (locale === "pt") return pt_link_order_page_title(inputs)
	if (locale === "ro") return ro_link_order_page_title(inputs)
	if (locale === "sk") return sk_link_order_page_title(inputs)
	if (locale === "sl") return sl_link_order_page_title(inputs)
	if (locale === "fi") return fi_link_order_page_title(inputs)
	if (locale === "sv") return sv_link_order_page_title(inputs)
	if (locale === "vi") return vi_link_order_page_title(inputs)
	if (locale === "tr") return tr_link_order_page_title(inputs)
	if (locale === "el") return el_link_order_page_title(inputs)
	if (locale === "bg") return bg_link_order_page_title(inputs)
	if (locale === "ru") return ru_link_order_page_title(inputs)
	if (locale === "sr") return sr_link_order_page_title(inputs)
	if (locale === "uk") return uk_link_order_page_title(inputs)
	if (locale === "ka") return ka_link_order_page_title(inputs)
	if (locale === "hi") return hi_link_order_page_title(inputs)
	if (locale === "th") return th_link_order_page_title(inputs)
	if (locale === "ko") return ko_link_order_page_title(inputs)
	if (locale === "zh") return zh_link_order_page_title(inputs)
	if (locale === "zh-tw") return zh_tw_link_order_page_title(inputs)
	if (locale === "ja") return ja_link_order_page_title(inputs)
	return en_link_order_page_title(inputs)
});